import React, { FC } from 'react';

import styled from 'styles/styled-components';

import SVGIcon from 'components/SVGIcon/SVGIcon';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import media from 'utils/mediaStyle';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';
import {
  arrowRightButton,
  DeliveryBanner,
  FastOrderBanner,
  FreshBanner,
  LeafOne,
  LeafThree,
  LeafTwo,
  ReturnBanner,
} from '../Images';
import messages from '../messages';
import { SectionContainer, SectionTitle } from './Partners';
import { MainButton, SecondaryButton } from './CommonComponents';

const Container = styled.div`
  &:before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    height: 50%;
    width: 100%;
    background: #ffffff;
  }
  ${({ whiteBackground }) =>
    whiteBackground &&
    `
      background: #ffffff;
      padding-bottom: 40px;
      margin-top: -40px;
    `}
`;

const BannerContainer = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  background: #d3f1a7;
  border-radius: 0px;
  padding: 40px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  position: relative;
  z-index: 1;
  ${media.md`
    border-radius: 16px;
    `}
`;

const BannerTitleWrapper = styled.div``;

const BannerTitle = styled.span`
  font-size: 40px;
  font-weight: 600;
  color: #242527;
  ${({ hightLight }) =>
    hightLight &&
    `
    color: #3C9041;
  `}
`;

const BannerSubTitle = styled.span`
  font-size: 14px;
  ${media.md`
    font-size: 18px;
    font-weight: 500;
    `}
`;

const BenefitContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 80px;
  background: #ffffff;
  padding: 10px;
  gap: 10px;
`;

const BenefitItemText = styled.span`
  font-size: 12px;
  font-weight: 500;
  ${media.md`
    font-size: 14px;
    `}
`;

const ButtonContainer = styled.div`
  margin: 24px auto 0;
  display: flex;
  align-items: center;
  gap: 16px;
  @media (max-width: 767px) {
    margin: 24px 0 0;
    width: 100%
      ${({ coupleButton }) =>
        coupleButton &&
        `
      flex-direction: column;
    `};
  }
`;

const Leaf1 = styled.img`
  position: absolute;
  top: 80px;
  left: 100px;
  width: 60px;
  z-index: -1;
  display: none;
  ${media.sm`
    display: initial
  `}
`;

const Leaf2 = styled.img`
  position: absolute;
  bottom: 0px;
  left: 25px;
  width: 130px;
  z-index: -1;
`;

const Leaf3 = styled.img`
  position: absolute;
  top: 40px;
  right: 0px;
  object-fit: cover;
  width: 66px;
  z-index: -1;
  ${media.sm`
     width: 130px;
    `}
`;
interface IProps {
  whiteBackground?: boolean;
  openContactForm?: () => void;
}
type Props = IProps & RouteComponentProps;

const Banner: FC<Props> = ({ whiteBackground, openContactForm, history }) => {
  const lang = localStorage.getItem('lang') || 'vi';
  const loggedIn = localStorage.getItem('token');

  return (
    <SectionContainer gray={!whiteBackground}>
      <Container whiteBackground={whiteBackground}>
        <BannerContainer>
          <Leaf1 src={LeafOne} />
          <Leaf2 src={LeafTwo} />
          <Leaf3 src={LeafThree} />
          {loggedIn ? (
            <div>
              {lang === 'vi' ? (
                <>
                  <SectionTitle highLight>Khám phá thêm nguồn hàng</SectionTitle>
                  <SectionTitle>&nbsp;cho doanh nghiệp của bạn</SectionTitle>
                </>
              ) : (
                <>
                  <SectionTitle highLight>
                    Explore more supplies
                    <SectionTitle>&nbsp;for your business</SectionTitle>
                  </SectionTitle>
                </>
              )}
            </div>
          ) : (
            <div>
              {lang === 'vi' ? (
                <>
                  <SectionTitle highLight>Sẵn sàng đặt hàng</SectionTitle>
                  <SectionTitle>&nbsp;cho doanh nghiệp của bạn?</SectionTitle>
                </>
              ) : (
                <>
                  <SectionTitle highLight>
                    Ready to Order&nbsp;
                    <SectionTitle>for Your Business?</SectionTitle>
                  </SectionTitle>
                </>
              )}
            </div>
          )}
          {loggedIn ? (
            <BannerSubTitle>
              <FormattedMessage {...messages.bannerSubtextLoggin} />
            </BannerSubTitle>
          ) : (
            <BannerSubTitle>
              <FormattedMessage {...messages.bannerSubtextNonLoggin} />
            </BannerSubTitle>
          )}
          {!loggedIn && (
            <BenefitContainer>
              <BenefitItem>
                <SVGIcon src={DeliveryBanner} />
                <BenefitItemText>
                  <FormattedMessage {...messages.bannerFreeShip} />
                </BenefitItemText>
              </BenefitItem>
              <BenefitItem>
                <SVGIcon src={ReturnBanner} />
                <BenefitItemText>
                  <FormattedMessage {...messages.bannerReturn} />
                </BenefitItemText>
              </BenefitItem>
              <BenefitItem>
                <SVGIcon src={FastOrderBanner} />
                <BenefitItemText>
                  <FormattedMessage {...messages.bannerConvenientOrder} />
                </BenefitItemText>
              </BenefitItem>
              <BenefitItem>
                <SVGIcon src={FreshBanner} />
                <BenefitItemText>
                  <FormattedMessage {...messages.bannerFresh} />
                </BenefitItemText>
              </BenefitItem>
            </BenefitContainer>
          )}
          {loggedIn ? (
            <ButtonContainer coupleButton>
              <SecondaryButton
                onClick={() => {
                  sendGA4Event(EventName.CLICK_REORDER_FAVORITE_FTB);
                  history.push('/favorite');
                }}
                type="default"
                fullWidth
              >
                <FormattedMessage {...messages.purchaseFromFavorite} />
              </SecondaryButton>
              <MainButton
                onClick={() => {
                  sendGA4Event(EventName.CLICK_KAMEREO_BRAND_FTB);
                  history.push('/thuong-hieu-kamereo');
                }}
                type="primary"
                style={{ background: '#43A047' }}
                fullWidth
              >
                <FormattedMessage {...messages.purchaseFromKamereoLabel} />
                <SVGIcon src={arrowRightButton} />
              </MainButton>
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <MainButton
                onClick={() => {
                  if (openContactForm) {
                    openContactForm();
                    sendGA4Event(EventName.START_SOURCING_FTB_CLICK);
                  }
                }}
                type="primary"
                style={{ background: '#43A047' }}
              >
                <FormattedMessage {...messages.registerNow} />
                <SVGIcon src={arrowRightButton} />
              </MainButton>
            </ButtonContainer>
          )}
        </BannerContainer>
      </Container>
    </SectionContainer>
  );
};

export default withRouter(Banner);
